import css from 'styled-jsx/css';
import { MQ_PHONE_ONLY, MQ_MEDIUM } from 'constants/mq';

// Going to explicitly ignore browsers that don't support Grid for now
export default css`
  .TeaserCard {
    position: relative;
    display: grid;
    grid-template-areas:
      'teaser teaser'
      '..... .......'
      '..... actions';
    /* We can use fixed size images for the search result teasers */
    /* grid-template-columns: 135px [info-start] 1fr [info-end]; */
    grid-template-columns: [info-start] 1fr 1fr [info-end];
    grid-template-rows: min-content [info-start] 1fr [info-end];
    grid-template-rows: -webkit-min-content [info-start] 1fr [info-end];
    background-color: #fff;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.15);
  }

  .TeaserCard :global(.Teaser) {
    grid-area: teaser;
  }

  .TeaserCard__info {
    grid-area: info;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 0 0.5rem 0.5rem;
    flex-wrap: wrap;
  }

  .TeaserCard__rating {
    display: flex;
    align-items: center;
  }

  .TeaserCard__ratingStar {
    margin-right: 0.125rem;
  }

  .TeaserCard__ratingStar :global(svg) {
    display: block;
    height: 12px;
    width: 12px;
  }

  .TeaserCard__ratingStars {
    margin-right: 0.125rem;
    list-style: none;
    display: flex;
  }

  .TeaserCard__ratingTotal {
    font-size: 12px;
    font-weight: 700;
    display: none;
  }

  .TeaserCard :global(.SaveRecipeActionButton__saveRecipeToBox) {
    grid-area: actions;
    width: 100%;
    margin-top: 0.5rem;
  }

  @media screen and ${MQ_PHONE_ONLY} {
    .TeaserCard :global(.SaveRecipeActionButton__saveRecipeToBox) {
      margin: 0.5rem 0rem;
    }
  }

  @media screen and ${MQ_MEDIUM} {
    .TeaserCard {
      grid-template-columns: [info-start] 1fr 1fr [info-end];
    }

    .TeaserCard__ratingStar :global(svg) {
      height: 15px;
      width: 15px;
    }

    .TeaserCard__ratingTotal {
      display: block;
    }
  }

  ${'' /* @media screen and ${MQ_LARGE} {
    .TeaserCard__ratingTotal {
      font-size: 1rem;
    }
  } */}
`;
